import { connect } from 'react-redux'
import { DateAuthorFragment as Component } from './DateAuthorFragment'
import { selectUserData } from '../../selectors/auth'

const mapStateToProps = selectUserData

export const DateAuthorFragment = connect(mapStateToProps)(Component)
